// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__M5KdX","label":"Category_label__vNP3N","content":"Category_content__pICUT","header":"Category_header__2ovF8","location":"Category_location__35Z1Y"};